import React, {useEffect, useState} from "react"
import {getLocale, storeLocale} from "../Utils/helpers";
import i18next from "i18next";
import {MenuItem, Select} from "@mui/material";
import {useAppThemeOptions, useSelfServiceThemeOptions} from "../Utils/hooks";
import {makeStyles} from "tss-react/mui";
import {ThemeType} from "../interfaces";
import {Theme} from "@mui/material/styles";

interface LanguageSelectorProps {
    selfService?: boolean
}

const useStyles = makeStyles<ThemeType>()((theme: Theme, options: ThemeType) => ({
    select: {
        color: options.headerTextColor ?? 'white',
        marginRight: theme.spacing(2),
        '&:before': {
            borderColor: options.headerTextColor ?? 'white',
        },
        '&:after': {
            borderColor: options.headerTextColor ?? 'white',
        },
        '&:not(.Mui-disabled):hover::before': {
            borderColor: options.headerTextColor ?? 'white',
        },
    },
    icon: {
        fill: options.headerTextColor ?? 'white',
    },
}))

const LanguageSelector: React.FC<LanguageSelectorProps> = ({selfService}) => {
    const [language, setLanguage] = useState(getLocale())
    const themeOptions = selfService ? useSelfServiceThemeOptions() : useAppThemeOptions()
    const { classes } = useStyles(themeOptions)

    useEffect(() => {
        (async () => {
            if (language) storeLocale(language)
            await i18next.changeLanguage(language)
        })()
    }, [language])

    return (<>
        <Select
            variant="standard"
            onChange={(e) => setLanguage(e.target.value as any)}
            value={language}
            className={classes.select}
            inputProps={{
                classes: {
                    icon: classes.icon,
                },
            }}
        >
            <MenuItem value="fi">FI</MenuItem>
            <MenuItem value="sv">SE</MenuItem>
            <MenuItem value="en">EN</MenuItem>
        </Select>
    </>)
}

export default LanguageSelector
